import { store } from '../../redux/store'
import { userSelectors } from '../../redux/userSlice'
import { fetchHelper } from '../../api/api'
import { userCoursesActions } from './userCoursesSlice'

export const fetchUserCourse = async ({
    classid,
    status,
    coursecode,
    fetchStatusIfNull = false,
}) => {
    const promises = [
        fetchHelper.get(`Course/${coursecode}`).then(res => {
            const course = { ...res.data }
            course.courseLessons.sort(
                (lessonA, lessonB) => lessonA.position - lessonB.position
            )
            course.courseLessons.forEach(lesson => {
                if (lesson.lessonTopics) {
                    lesson.lessonTopics.sort(
                        (topicA, topicB) => topicA.position - topicB.position
                    )
                } else {
                    lesson.lessonTopics = []
                }
            })
            return course
        }),
        fetchHelper
            .get(`CourseProgress/GetClassProgress/${classid}`)
            .then(res => res.data)
            // TODO: Remove this once API is fixed
            // If the class progress doesn't exist, the API returns an error
            // This won't happen once payment is implemented, as the progress
            // Must exist before it becomes a Customercourse
            .catch(err => {
                if (process.env.NODE_ENV === 'development') console.warn(err)
                // ignore it
                return {}
            }),
        // Normally, this would never happen, as this function would normally
        // be called as part of fetchUserCourses, but if we only have the
        // classid and coursecode, and also need the status...
        !!status && fetchStatusIfNull
            ? fetchHelper
                  .get(`Customercourse/${classid}`)
                  .then(res => res.data.status)
            : Promise.resolve(status),
    ]
    const [courseItem, progressDetails, courseStatus] = await Promise.all(
        promises
    )

    // Default to the first topic/lesson if there is no current one
    // That means the user hasn't done anything in the course yet

    const currentTopicId =
        progressDetails?.items?.find(t => t.current === true)?.topicId ??
        progressDetails?.items?.[0]?.topicId

    const currentLessonId =
        courseItem.courseLessons.find(lesson => {
            return (
                lesson.lessonTopics &&
                lesson.lessonTopics.some(topic => topic.id === currentTopicId)
            )
        })?.lessonid ?? courseItem.courseLessons[0]?.lessonid

    return {
        ...courseItem,
        classid,
        currentTopicId,
        currentLessonId,
        progressDetails,
        status: courseStatus,
    }
}

export const fetchUserCourses = async params => {
    const state = store.getState()
    const userDetails = userSelectors.userDetails(state)
    const res = await fetchHelper.get(
        `Customercourse/AllCourses/${userDetails.email}`,
        { params }
    )
    const courses = res.data
    return Promise.all(
        courses.map(({ classid, status, coursecode }) =>
            fetchUserCourse({ classid, status, coursecode })
        )
    )
}

export const getUserCourses = params => async dispatch => {
    dispatch(userCoursesActions.getUserCoursesRequest())
    try {
        const apiResponse = await fetchUserCourses(params)
        const courses = apiResponse.reduce((acc, courseItem) => {
            acc.push({
                id: courseItem.coursecode,
                ...courseItem,
            })
            return acc
        }, [])
        dispatch(
            userCoursesActions.getUserCoursesRequestSuccess({
                courses,
            })
        )
    } catch (error) {
        if (process.env.NODE_ENV === 'development') console.warn(error)
        dispatch(userCoursesActions.getUserCoursesRequestFailure(error.message))
    }
}
